import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/ClinicalOperations`;

/**
 * Crea una nueva observación clínica asociada a un paciente.
 *
 * @param {Object} observationData
 * @param {string} observationData.cipId - CIP ID del paciente
 * @param {string} observationData.message - Texto de la observación (max 2000 chars)
 * @param {number} observationData.componentId - ID del componente origen (control.TAB_COMPONENTS)
 * @param {number|null} [observationData.priority] - Prioridad (reservado para uso futuro)
 * @param {number} observationData.employeeId - ID del empleado que crea la observación
 * @param {number} [observationData.status=23] - Estado inicial (23=Open)
 *
 * Ejemplo de llamada:
 * POST /api/ClinicalOperations/observations-v2/insert
 * Body: { "cipId": "12345", "message": "...", "componentId": 1, "priority": null, "employeeId": 42, "status": 23 }
 *
 * Respuesta exitosa (200):
 * { "result": 0, "message": "Observation created successfully", "observationId": 157 }
 *
 * Posibles errores (400):
 * { "result": 1, "message": "CIP ID is required" }
 * { "result": 1, "message": "Message is required" }
 * { "result": 1, "message": "Employee not found" }
 * { "result": 1, "message": "Component not found" }
 */
const insertObservation = async (observationData) => {
  try {
    const response = await axios.post(`${API_URL}/observations-v2/insert`, observationData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error inserting observation:", error);
    throw error;
  }
};

export default insertObservation;
